import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { PopperTooltip } from "~/common/components/Tooltip";
import { ActionTextLinkCell } from "~/features/search/components/ProductResults/views/TabularView/ProductTabularViewActionCell/ProductTabularViewActionCell";
import { Icon } from "~/common/components/icon/Icon";
import { IconType } from "~/common/components/icon/IconType";
import { IconSize } from "~/common/components/icon/IconSize";

interface CadButtonProps {
  url?: string;
  hasCad?: boolean;
  onClick?: () => void;
  target?: string;
  "data-test-id"?: string;
  "data-ta-spec"?: string;
  "data-ta-title"?: string;
  className?: string;
}

export const OpenCadAction = ({ url, hasCad, className, ...rest }: CadButtonProps) => {
  const { t } = useTranslation();
  let element = (
    <ActionTextLinkCell
      className={classNames("scha__action-cell__cad", !hasCad && "action-text-cell__missing-cad", className)}
      href={url}
      {...rest}
    >
      <Icon size={IconSize.FONT_24} type={IconType.Cad} />
    </ActionTextLinkCell>
  );

  if (!hasCad) {
    element = (
      <PopperTooltip
        tooltipContent={t("product.requestCad")}
        placement="bottom-end"
        isNavigation
        className={classNames("scha__personal-nav__tooltip")}
      >
        {element}
      </PopperTooltip>
    );
  }

  return element;
};
